import { defineMessages } from 'react-intl'

export default defineMessages({
  invalidUploadFileType: {
    id: 'AttachmentUpload.invalidUploadFileType',
    defaultMessage: 'This file type is not supported. Please choose a {types} file'
  },
  uploadFailure: {
    id: 'AttachmentUpload.uploadFailure',
    defaultMessage: 'File upload incomplete'
  },
  cancelDelete: {
    id: 'AttachmentUpload.cancelDelete',
    defaultMessage: 'Keep file'
  },
  confirmDelete: {
    id: 'AttachmentUpload.confirmDelete',
    defaultMessage: 'Delete file'
  },
  deleteLoading: {
    id: 'AttachmentUpload.deleteLoading',
    defaultMessage: '...Loading'
  },
  deleteMessage: {
    id: 'AttachmentUpload.deleteMessage',
    defaultMessage: 'Are you sure you want to delete this file?'
  },
  deleteSubMessage: {
    id: 'AttachmentUpload.deleteSubMessage',
    defaultMessage:
      'will be removed permanently from your document list and will no longer work for the targeted audience.'
  },
  uploading: {
    id: 'AttachmentUpload.uploading',
    defaultMessage: 'Uploading file to Workgrid'
  },
  dropZoneDescription: {
    id: 'AttachmentUpload.dropZoneDescription',
    defaultMessage: 'Drag files here or click to upload'
  },
  tryAgain: {
    id: 'AttachmentUpload.tryAgain',
    defaultMessage: 'Try again'
  },
  cancel: {
    id: 'AttachmentUpload.cancel',
    defaultMessage: 'Cancel'
  }
})
